import * as React from "react";
import Link from "../link";
import { graphql, useStaticQuery } from "gatsby";
import AustinImg from "../../images/austin-circle@2x.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";

function Branding(): JSX.Element {
  const {
    site: {
      siteMetadata: { title },
    },
  } = useStaticQuery(graphql`
        {
            site {
                siteMetadata {
                    title
                }
            }
        }
    `);

  return (
    <div className="row justify-content-center">
      <Link
        href="/"
        className="navbar-brand d-flex flex-md-column text-uppercase fw-bold text-center mx-0"
      >
        <img
          src={AustinImg}
          className={"w-100 mb-3 d-none d-md-block austin-nav-photo"}
          alt="The myth, the man, the legend."
        />
        <span className="brand-title">{title}</span>
      </Link>
      <div className="d-none d-md-flex justify-content-center gap-3 mt-2 pb-3">
        <Link
          href="https://github.com/farmerau"
          className="nav-link p-0"
          aria-label="GitHub"
        >
          <FontAwesomeIcon icon={faGithub} size="lg" />
        </Link>
        <Link
          href="https://linkedin.com/in/farmerau"
          className="nav-link p-0"
          aria-label="LinkedIn"
        >
          <FontAwesomeIcon icon={faLinkedin} size="lg" />
        </Link>
      </div>
    </div>
  );
}

export default Branding;
